/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaDatiAggiuntivi
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaDatiAggiuntiviCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    postVenditaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.loggerSrvc = loggerSrvc;
    this.messaggiFctr = messaggiFctr;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.domainSrvc = domainSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Altezza della griglia carte
     */
    this.altezzaTabellaCarte = 0;

    /**
     * altezza griglia del conto corrente
     */
    this.altezzaTabellaConti = 0;

    /**
     * altezza griglia del conto corrente
     */
    this.altezzaTabellacurrentCarta = 0;

    /**
     * Altezza di una riga della griglia dei carte
     */
    this.altezzaRigaCarte = 30;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.postVenditaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone completo
     */
    this.postVenditaCartaDebitoIntSrvc.completaVisibile = function () {
      return !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone indietro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroVisibile = function () {
      return !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly();
    };

    /**
     * Implementazione nel service dell'abilitazione del bottone completa
     */
    this.postVenditaCartaDebitoIntSrvc.completaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return false;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO) {
        return !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentBlocco;
      } else if (
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO ||
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.DUP_CARTA ||
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.RIF_CARTA
      )
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentFunzione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.importoQuota &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.condizione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteGiornaliero &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteMensile &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteDownoption
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INTESTA)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.nuovaIntestazione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO)
        return !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentConto;
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita
        );
      return false;
    };

    function recuperaBlocco() {
      recuperaDominio(
        'recupero Blocco Carte', // per log
        CONSTANTS.REST.POST_VENDITA.ELENCO_BLOCCO, // funzione
        cllBckBlocco //cllBack
      );
    }

    function recuperaCondizioni() {
      recuperaDominio(
        'recupero Condizioni Carta', // per log
        CONSTANTS.REST.POST_VENDITA.ELENCO_CONDIZIONI, // funzione
        cllBckCond //cllBack
      );
    }

    function recuperaLimiti(prod) {
      recuperaDominio(
        'recupero Limiti Carta',
        CONSTANTS.REST.POST_VENDITA.ELENCO_LIMITI.replace('{codProdotto}', prod),
        cllBackLimiti
      );
    }

    function cllBckBlocco(response) {
      self.postVenditaCartaDebitoIntSrvc.elencoBlocco = response.data.result;
    }

    function cllBckCond(response) {
      self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = response.data.result;
    }

    function cllBackLimiti(response) {
      self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = response.data.result;
    }

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
      if (
        !self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi ||
        !self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione
      ) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
          indirizzoSpedizione: {
            via: null,
            numero: null,
            provincia: null,
            comune: {
              valore: null
            },
            cap: null,
            nazione: null,
            localita: null
          }
        };
      }

      $q.all([self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')])
        .then(function (responses) {
          self.paesi = responses[0];

          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // indirizzo nazione spedizione forzato a ITALIA (086)
          self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;

          if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune != null) {
            self.recuperaComuni(false);
            self.recuperaCAP(false);
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
          if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita) {
            self.recuperaLocalita(false);
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori) {
      var provincia = '';
      provincia = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        self.comuni = [];
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        self.comuni = domain;
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     */
    function recuperaDominio(msgLog, fun, callback) {
      self.spinner.showSpinner++;

      // logging
      self.loggerSrvc.log('postVenditaDatiAggiuntiviCtrl', self.loggerSrvc.INFO, 'Inizio ' + msgLog);

      self.postVenditaCartaDebitoIntSrvc
        .promiseRecuperaDominio(fun)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (callback) callback(response);

            self.loggerSrvc.log('postVenditaDatiAggiuntiviCtrl', self.loggerSrvc.INFO, 'Termine ' + msgLog);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.SEVERE,
              'Errore ' + msgLog + self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    }

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.loadElencoCarteGrid = function (arrayCurrentCarta) {
      const defAltezzaTabellaCarte = 2;

      if (arrayCurrentCarta.length > defAltezzaTabellaCarte)
        self.altezzaTabellaCarte = defAltezzaTabellaCarte * self.altezzaRigaCarte + 60;
      else self.altezzaTabellaCarte = arrayCurrentCarta.length * self.altezzaRigaCarte + 60;

      self.carteGridOptions = {
        enableSorting: true,
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza',
            type: 'date',
            cellFilter: "date:'dd/MM/yyyy'"
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '8%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: arrayCurrentCarta
      };
    };

    /**
     * Funzione per caricare l'elenco dei conti collegati a ndg
     */
    this.loadElencoContiGrid = function () {
      const defAltezzaTabellaConti = 2;

      if (self.postVenditaCartaDebitoIntSrvc.elencoConti.length >= defAltezzaTabellaConti)
        self.altezzaTabellaConti = self.postVenditaCartaDebitoIntSrvc.elencoConti.length * self.altezzaRigaCarte + 40;
      else self.altezzaTabellaConti = defAltezzaTabellaConti * self.altezzaRigaCarte + 40;

      self.contiGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.rapporto'),
            field: 'numeroRapporto',
            width: '20%',
            name: 'numeroRapporto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.iban'),
            field: 'iban',
            width: '20%',
            name: 'iban'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.descrizione'),
            field: 'descrizione',
            width: '15%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.saldo'),
            field: 'saldo',
            width: '10%',
            name: 'saldo'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.intestatario'),
            field: 'intestatario',
            width: '10%',
            name: 'intestatario'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.stato'),
            field: 'stato',
            width: '10%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.dataapertura'),
            field: 'dataApertura',
            cellFilter: "date:'dd/MM/yyyy'",
            width: '15%',
            name: 'dataApertura'
          }
        ],
        data: self.postVenditaCartaDebitoIntSrvc.elencoConti,
        onRegisterApi: function (gridApi) {
          gridApi.grid.modifyRows(self.contiGridOptions.data);

          // Se era già stato salvato il conto la recupero e seleziono
          if (self.postVenditaCartaDebitoIntSrvc.elencoConti && self.postVenditaCartaDebitoIntSrvc.currentIban) {
            angular.forEach(self.postVenditaCartaDebitoIntSrvc.elencoConti, function (conto, index) {
              if (conto.iban === self.postVenditaCartaDebitoIntSrvc.currentIban) {
                gridApi.selection.selectRow(self.postVenditaCartaDebitoIntSrvc.elencoConti[index]);
              }
            });
          }
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            self.selezionaConto(row);
          });
        }
      };
    };

    /**
     * Funzione per caricare la tabella della carta selezionata
     */
    this.loadCurrentCartaGrid = function () {
      const defAltezzaTabellaConti = 1;

      self.altezzaTabellacurrentCarta = defAltezzaTabellaConti * self.altezzaRigaCarte + 60;

      var listaCarte = [];
      // viene aggiunta alla lista da visualizzare solo carta selezionata nello step DEFINIZIONE
      listaCarte.push(self.postVenditaCartaDebitoIntSrvc.currentCarta);

      self.currentCartaGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '8%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: listaCarte
      };
    };

    /**
     * Funzione assegnata alla selezione di una riga di conto corrente
     */
    this.selezionaConto = function (conto) {
      if (conto.isSelected) {
        this.postVenditaCartaDebitoIntSrvc.currentConto = conto.entity;
        //Mappo sul campo idPraticaConto da restituire a BE il valore
        this.postVenditaCartaDebitoIntSrvc.currentConto.idPraticaConto = conto.entity.idPraticaProposta;
      } else this.postVenditaCartaDebitoIntSrvc.currentConto = null;
    };

    this.recuperaElencoConti = function (ndgList) {
      self.spinner.showSpinner++;
      var promiseList = [];
      for (var i = 0; i < ndgList.length; i++) {
        promiseList.push(self.postVenditaCartaDebitoIntSrvc.promiseElencoConti(ndgList[i]));
      }
      $q.all(promiseList)
        .then(
          function (responses) {
            if (self.messaggiFctr.processaResponse(responses)) {
              return;
            }

            self.postVenditaCartaDebitoIntSrvc.elencoConti = [];
            for (var responsesIndex = 0; responsesIndex < responses.length; responsesIndex++) {
              if (responses[responsesIndex].data && responses[responsesIndex].data.result) {
                for (var dataIndex = 0; dataIndex < responses[responsesIndex].data.result.length; dataIndex++) {
                  self.postVenditaCartaDebitoIntSrvc.elencoConti.push(responses[responsesIndex].data.result[dataIndex]);
                }
              }
            }

            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.INFO,
              'Recupeo con successo conti ndg ' + self.postVenditaCartaDebitoIntSrvc.ndg
            );

            self.loadElencoContiGrid();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero conti associati ndg ' +
                self.postVenditaCartaDebitoIntSrvc.ndg +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // nel caso in cui sono nella modifica del conto devo recuperare
        // dall'elenco dei conti tutti quelli con numero conto = a quello selezionato
        // e riproporli.
        if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO) {
          // cerco le carte con stesso conto.
          self.arrCarteFiltered = self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.filter(function (utenza) {
            return utenza.conto === self.postVenditaCartaDebitoIntSrvc.currentCarta.conto;
          });

          self.loadElencoCarteGrid(self.arrCarteFiltered);
        } else self.loadElencoCarteGrid([self.postVenditaCartaDebitoIntSrvc.currentCarta]);

        // in base alla funzione recupero i dati di dominio
        if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO) recuperaBlocco();
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI)
          recuperaCondizioni();
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO) {
          self.recuperaDomini();
        } else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI)
          recuperaLimiti(self.postVenditaCartaDebitoIntSrvc.currentCarta.codiceUtenza);
        // FIX inserisci il prodotto preso dalla riga.
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO) {
          self.postVenditaCartaDebitoIntSrvc.elencoConti = null;
          self.loadCurrentCartaGrid();
          self.spinner.showSpinner++;
          //          var listaConti = [];
          //          listaConti.push(self.postVenditaCartaDebitoIntSrvc.currentCarta);
          //
          //          self.loadElencoCarteGrid(listaConti);

          //EMonetica-829 - Recuperare gli ndg anche delle coi
          $q.all([
            self.postVenditaCartaDebitoIntSrvc.promiseRecuperaAnagraficaCoi(self.postVenditaCartaDebitoIntSrvc.ndg)
          ]).then(function (response) {
            var ndgList = [];
            if (response[0].data.result.length > 0) {
              console.log('Ndg trovati ' + response[0].data.result);
              angular.forEach(response[0].data.result, function (ndg, index) {
                ndgList.push(ndg);
              });
              console.log('Ndg inseriti ' + ndgList);
            }

            ndgList.push(self.postVenditaCartaDebitoIntSrvc.ndg);
            self.recuperaElencoConti(ndgList);
          });
          //              .finally(function () {
          //                if (self.spinner.showSpinner > 0) {
          //                  self.spinner.showSpinner = 0;
          //                }
          //              });
        }
      });
    };

    self.init();
  };

  PostVenditaDatiAggiuntiviCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'postVenditaCartaDebitoInt/postVenditaDatiAggiuntivi/postVenditaDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaDatiAggiuntiviComponent = {
    controller: PostVenditaDatiAggiuntiviCtrl,
    controllerAs: 'postVenditaDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaDatiAggiuntivi', PostVenditaDatiAggiuntiviComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/postVenditaCartaDebitoInt/postVenditaDatiAggiuntivi/postVenditaDatiAggiuntivi.cmpt.js
// module id = 20
// module chunks = 0